// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","nav-active":"Navigation_nav-active__b1mGx","link":"Navigation_link__13qe6","active":"Navigation_active__1vK5v"};